import { createConfirmation } from 'react-confirm';
import AlertDialogComponent from '../components/misc/AlertDialog';

// Taken from the react-confirm manual: https://www.npmjs.com/package/react-confirm

// create confirm function
const confirmation = createConfirmation(AlertDialogComponent);

// This is optional. But I recommend to define your confirm function easy to call.
export function alertGeneral(title, text, options = {}) {
    // You can pass whatever you want to the component. These arguments will be your Component's props
    return confirmation({ title, text, options });
}

// A version of the confirm function, which is a little easier to use in the normal use-case (We don't have to write ".then(...)").
export function alert(title, text, onOk, options = {}) {
    const onCancel = () => {};
    return alertGeneral(title, text, options).then(onOk, onCancel);
}



// WEBPACK FOOTER //
// ./src/client/src/utils/alertDialog.js